export const setStorageItem = <T>(key: string, data: T): void => {
  window.sessionStorage.setItem(key, JSON.stringify(data));
};

export const getStorageItem = <T>(key: string): T | undefined => {
  try {
    const data = window.sessionStorage.getItem(key);
    return data ? (JSON.parse(data) as unknown as T) : undefined;
  } catch (error: unknown) {
    if (error instanceof Error) {
      console.error('Error getting item from sessionStorage: ', error);
    }
    return undefined;
  }
};

export const removeStorageItem = (key: string): void => {
  window.sessionStorage.removeItem(key);
};
